// src/redux/selectOptionsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ProjectNameOptions: [],
  StatusOptions: [],
  MilestonesNameOptions: [],
  UserNameOptions: [],
  PriorityNameOptions: [],
  SeverityNameOptions: [],
  ClientNameOptions: [],
  timesheetViewOptions: [],
  tasklistdatas: [],
  TaskNameOptions: [],
  userNamesByProjects: [],
  ownerNameOptions: [],
  PortalUserNameOptions: [],
  PortalClients: [],
  loginUserName: null, // filled from the API (see App.js), never from localStorage
  issueNameOptions: [],
  taskId: null,
  // timesheet popup
  showProjectPopup: false,
  timesheetProjectSpan: null,
  timesheetFromDate: null,
  timesheetToDate: null,
  projectName: "",
  otCounts: {
    total_count: 0,
    total_pending: 0,
    total_approved: 0,
    total_rejected: 0,
  },
};

const selectOptionsSlice = createSlice({
  name: "selectOptions",
  initialState,
  reducers: {
    setProjectNameOptions: (state, action) => {
      state.ProjectNameOptions = action.payload; // Set options for Field A
    },
    setStatusOptions: (state, action) => {
      state.StatusOptions = action.payload; // Set options for Field B
    },
    setMilestonesNameOptions: (state, action) => {
      state.MilestonesNameOptions = action.payload; // Set options for Field C
    },
    setUserNameOptions: (state, action) => {
      state.UserNameOptions = action.payload; // Set options for Field C
    },
    setPriorityNameOptions: (state, action) => {
      state.PriorityNameOptions = action.payload; // Set options for Field C
    },
    setSeverityNameOptions: (state, action) => {
      state.SeverityNameOptions = action.payload; // Set options for Field C
    },
    setClientNameOptions: (state, action) => {
      state.ClientNameOptions = action.payload; // Set options for Field C
    },
    setTaskIdOption: (state, action) => {
      state.taskId = action.payload; // Set taskId
    },
    setTimesheetViewOptions: (state, action) => {
      state.timesheetViewOptions = action.payload;
    },
    setOTCounts: (state, action) => {
      state.otCounts = { ...state.otCounts, ...action.payload };
    },
    setTasklistDatas: (state, action) => {
      state.tasklistdatas = action.payload;
    },
    setTaskNameOptions: (state, action) => {
      state.TaskNameOptions = action.payload;
    },
    setUserNamesByProjects: (state, action) => {
      state.userNamesByProjects = action.payload;
    },
    setownerNameOptions: (state, action) => {
      state.ownerNameOptions = action.payload;
    },
    setPortalUserNameOptions: (state, action) => {
      state.PortalUserNameOptions = action.payload;
    },
    setPortalClients: (state, action) => {
      state.PortalClients = action.payload;
    },
    setloginUserName: (state, action) => {
      state.loginUserName = action.payload;
    },
    setIssueNameOptions: (state, action) => {
      state.issueNameOptions = action.payload;
    },
    setShowProjectPopup: (state, action) => {
      state.showProjectPopup = action.payload; // 🔴 Manage popup state
    },
    setTimesheetProjectSpan: (state, action) => {
      state.timesheetProjectSpan = action.payload;
    },
    setTimesheetFromDate: (state, action) => {
      state.timesheetFromDate = action.payload;
    },
    setTimesheetToDate: (state, action) => {
      state.timesheetToDate = action.payload;
    },
    setprojectName: (state, action) => {
      state.projectName = action.payload;
    },
  },
});

export const {
  setProjectNameOptions,
  setStatusOptions,
  setMilestonesNameOptions,
  setUserNameOptions,
  setPriorityNameOptions,
  setSeverityNameOptions,
  setClientNameOptions,
  setTaskIdOption,
  setTimesheetViewOptions,
  setTasklistDatas,
  setTaskNameOptions,
  setPortalUserNameOptions,
  setloginUserName,
  setUserNamesByProjects,
  setIssueNameOptions,
  setOTCounts,
  setownerNameOptions,
  setPortalClients,
  setShowProjectPopup,
  setTimesheetProjectSpan,
  setTimesheetFromDate,
  setTimesheetToDate,
  setprojectName,
} = selectOptionsSlice.actions;

export default selectOptionsSlice.reducer;
